module.exports = __webpack_public_path__ + "static/media/zola-logo-minimal.d1f67bfb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/zola-logo-minimal.svg
// module id = 3838
// module chunks = 68